import React from 'react'
import ReactDOM from 'react-dom/client'
import TelecomBillingSystem from './src/App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <TelecomBillingSystem />
  </React.StrictMode>,
)